import { Flex, Spacer, Text } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import GradientText from "src/shared/components/GradientText";
import { SomethingWentWrongImg } from "src/static/img";

const Maintenance: React.FC = () => (
  <Page>
    <Flex column align="center" justify="center">
      <ImageWrapper>
        <img src={SomethingWentWrongImg} alt="" aria-hidden />
      </ImageWrapper>
      <Spacer height={40} />
      <Title gradient="gradientRedBlue172" mods="heading">
        Under maintenance
      </Title>
      <Spacer height={10} />
      <Body mods="heading">
        The platform is currently down for maintenance, sorry for any
        inconvenience.
      </Body>
    </Flex>
  </Page>
);

export default Maintenance;

const Page = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  background: ${({ theme }) => theme.globalConstants.color.white};
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(360px, 90vw);
  height: min(320px, 38vh);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ${({ theme }) => theme.mediaQueries.medium`
    width: min(300px, 85vw);
    height: min(280px, 32vh);
  `}

  ${({ theme }) => theme.mediaQueries.largeMobile`
    width: min(280px, 90vw);
    height: min(200px, 26vh);
  `}
`;

const Title = styled(GradientText)`
  && {
    width: 100%;
    font-size: 35px;
    text-align: center;
  }

  ${({ theme }) => theme.mediaQueries.largeMobile`
    && {
      font-size: 20px;
    }
  `}
`;

const Body = styled(Text)`
  && {
    max-width: 620px;
    font-size: 20px;
    text-align: center;
  }

  ${({ theme }) => theme.mediaQueries.largeMobile`
    && {
      font-size: 16px;
    }
  `}
`;
